import {
  AutosuggestProps,
  HomeVideoReviewSearchItem
} from "@bluframe/mightychroma-mightytool-frontend-types"

import ImagesGrid from "./ImagesGrid"

export interface Props {
  homeVideoReviewIds: string[]
  homeVideoReviewTitles: HomeVideoReviewSearchItem[]
  isAutoSuggestLoading: boolean
  isCreateHomeVideoImagesGridLoading: boolean
  onClickGenerate: () => void

  onSelectHomeVideoReviewId: (index: number) => (
    id: string,

    name: string
  ) => void
  onGetSuggestions: AutosuggestProps["onGetSuggestions"]
  reviewNames: string[]
}

export interface ComponentProps extends Props {}

export default ImagesGrid
